/*global Modernizr, dd_map_locations, dd_generated_locations, double_dave_map_styles, alert, console */
/*jslint browser:true */

(function() {
  'use strict';

  var map = null;

  var location_map = document.getElementById('dd-location-map');

  if(!location_map) {
    return;
  }

  document.body.addEventListener('dd-map', (e) => {
    var SVGMarker = get_dd_marker(),
        marker_position = new google.maps.LatLng(31.695456, -98.620484);

    map = new google.maps.Map(location_map.querySelector('.map-container'), {
      zoom: 10,
      maxZoom: 17,
      center: marker_position,
      mapTypeControl: false,
      panControl: false,
      streetViewControl: false,
      fullscreenControl: false,
      zoomControl: true,
      zoomControlOptions: {
        position: google.maps.ControlPosition.RIGHT_BOTTOM
      },
      scaleControl: false,
      scrollwheel: false,
      styles: double_dave_map_styles
    });

    dd_map_locations.forEach((location) => {
      if(location.latitude !== '' && location.longitude !== '') {
        let location_position = new google.maps.LatLng(location.latitude, location.longitude);
        let marker_color = '#312e2c';

        if(dd_generated_locations.includes(location.id)) {
          marker_color = '#F06820'
        }

        var marker_html = `<div class="marker-icon"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 60 60" style="enable-background:new 0 0 60 60;" xml:space="preserve">
            <path class="marker-border" style="fill:#FFFFFF;" d="M48.4,8.5c-0.8-0.8-1.6-1.6-2.3-2.3C36.3-2.7,21.2-2,12.2,7.8C3.3,17.6,4,32.7,13.8,41.6 c0.2,0.2,0.5,0.5,0.8,0.7c5.6,4.6,10.3,10.3,13.8,16.7c0.3,0.6,1,1,1.8,1c0.7,0,1.4-0.4,1.8-1l0.2-0.3c3.5-6.3,8.2-11.9,13.7-16.5 C55.9,33.6,57,18.5,48.4,8.5z"/>
            <path class="marker-background" style="fill:${marker_color};" d="M46,10.4c-0.6-0.7-1.2-1.3-1.9-1.9C40,4.8,35,3,29.9,3c-5.7,0-11.4,2.3-15.5,6.8 c-7.8,8.5-7.2,21.8,1.4,29.6c0.2,0.2,0.4,0.4,0.7,0.6c5.4,4.5,10,9.9,13.6,16c3.6-6.2,8.3-11.6,13.8-16.1c4.2-3.6,6.7-8.7,7.1-14.3 C51.4,20,49.6,14.6,46,10.4z M30.1,34.1c-5.5,0-10-4.5-10-10s4.5-10,10-10s10,4.5,10,10S35.6,34.1,30.1,34.1z"/>
            </svg></div>`;

        new SVGMarker({
          map: map,
          position: location_position,
          clickable: true,
          icon: {
            size: new google.maps.Size(60, 60),
            anchor: new google.maps.Point(30, 60),
            class: 'SVGMarker',
            html: marker_html
          }
        });

        if(dd_generated_locations.includes(location.id)) {
          map.setCenter(location_position);
        }
      }
    });
  });
}());